import React from 'react';
import RegistrationFormProps from '../registration.types';
import FormControl from '@material-ui/core/FormControl';
import ExistingIdentityVerification from './ExistingIdentityVerification';
import NewIdentityVerification from './NewIdentityVerification';
import { OnlineRegistrationType } from '../../../__generated__/pge-types';

interface AccountVerificationProps extends RegistrationFormProps {
  classes: any;
}

const AccountVerification = (props: AccountVerificationProps) => {
  const { form } = props;
  const availableIDTypes = form.values.availableExistingIDTypes || [];
  const isExistingIDAvailable = availableIDTypes.length > 0;

  return (
    <FormControl component={'fieldset'} style={{ width: '100%' }}>
      {isExistingIDAvailable && <ExistingIdentityVerification {...props} />}
      {!isExistingIDAvailable && <NewIdentityVerification {...props} />}
    </FormControl>
  );
};

export default AccountVerification;
